import ApiBase from "./ApiBase";

class UserApi {
  // Fetch all users
  fetchAllUsers() {
    return ApiBase.get("/users");
  }

  // Add a new user
  addUser(data) {
    return ApiBase.post("/users", data);
  }

  // Edit an existing user
  editUser(userId, data) {
    return ApiBase.put(`/users/${userId}`, data);
  }

  // Delete a user
  deleteUser(userId) {
    return ApiBase.delete(`/users/${userId}`);
  }

  // Toggle the role of a user (Admin/User)
  toggleUserRole(userId) {
    return ApiBase.put(`/users/${userId}/toggle-role`);
  }
}

export default new UserApi();
